import { jsonConstants } from '@thoughtspot/json-constants';
export var PRIVILEGES;
(function (PRIVILEGES) {
    PRIVILEGES["ADMINISTRATION"] = "ADMINISTRATION";
    PRIVILEGES["AUTHORING"] = "AUTHORING";
    PRIVILEGES["USERDATAUPLOADING"] = "USERDATAUPLOADING";
    PRIVILEGES["DATADOWNLOADING"] = "DATADOWNLOADING";
    PRIVILEGES["SHAREWITHALL"] = "SHAREWITHALL";
    PRIVILEGES["DATAMANAGEMENT"] = "DATAMANAGEMENT";
    PRIVILEGES["JOBSCHEDULING"] = "JOBSCHEDULING";
    PRIVILEGES["A3ANALYSIS"] = "A3ANALYSIS";
    PRIVILEGES["BYPASSRLS"] = "BYPASSRLS";
    PRIVILEGES["EXPERIMENTALFEATUREPRIVILEGE"] = "EXPERIMENTALFEATUREPRIVILEGE";
    PRIVILEGES["RANALYSIS"] = "RANALYSIS";
    PRIVILEGES["ENABLESPOTAPPCREATION"] = "ENABLESPOTAPPCREATION";
    PRIVILEGES["SYNCMANAGEMENT"] = "SYNCMANAGEMENT";
    PRIVILEGES["CAN_CREATE_CATALOG"] = "CAN_CREATE_CATALOG";
    PRIVILEGES["LIVEBOARD_VERIFIER"] = "LIVEBOARD_VERIFIER";
    PRIVILEGES["ROLE_ADMINISTRATION"] = "ROLE_ADMINISTRATION";
    PRIVILEGES["USER_ADMINISTRATION"] = "USER_ADMINISTRATION";
    PRIVILEGES["GROUP_ADMINISTRATION"] = "GROUP_ADMINISTRATION";
    PRIVILEGES["CAN_MANAGE_CUSTOM_CALENDAR"] = "CAN_MANAGE_CUSTOM_CALENDAR";
    PRIVILEGES["ORG_ADMINISTRATION"] = "ORG_ADMINISTRATION";
    PRIVILEGES["CAN_MANAGE_WORKSHEET_VIEWS_TABLES"] = "CAN_MANAGE_WORKSHEET_VIEWS_TABLES";
    PRIVILEGES["TAGMANAGEMENT"] = "TAGMANAGEMENT";
    PRIVILEGES["APPLICATION_ADMINISTRATION"] = "APPLICATION_ADMINISTRATION";
    PRIVILEGES["BACKUP_ADMINISTRATION"] = "BACKUP_ADMINISTRATION";
    PRIVILEGES["SYSTEM_INFO_ADMINISTRATION"] = "SYSTEM_INFO_ADMINISTRATION";
    PRIVILEGES["AUTHENTICATION_ADMINISTRATION"] = "AUTHENTICATION_ADMINISTRATION";
    PRIVILEGES["BILLING_INFO_ADMINISTRATION"] = "BILLING_INFO_ADMINISTRATION";
    PRIVILEGES["PREVIEW_THOUGHTSPOT_SAGE"] = "PREVIEW_THOUGHTSPOT_SAGE";
    PRIVILEGES["CAN_USE_SPOTTER"] = "CAN_USE_SPOTTER";
    PRIVILEGES["CAN_MANAGE_SPOTTER"] = "CAN_MANAGE_SPOTTER";
    PRIVILEGES["CAN_MANAGE_VERSION_CONTROL"] = "CAN_MANAGE_VERSION_CONTROL";
    PRIVILEGES["CAN_SETUP_VERSION_CONTROL"] = "CAN_SETUP_VERSION_CONTROL";
    PRIVILEGES["THIRDPARTY_ANALYSIS"] = "THIRDPARTY_ANALYSIS";
    PRIVILEGES["CAN_MANAGE_INPUT_TABLES"] = "CAN_MANAGE_INPUT_TABLES";
    PRIVILEGES["CAN_EDIT_INPUT_TABLES"] = "CAN_EDIT_INPUT_TABLES";
    PRIVILEGES["CAN_CREATE_LIVEBOARD"] = "CAN_CREATE_LIVEBOARD";
    PRIVILEGES["CAN_CREATE_ANSWERS"] = "CAN_CREATE_ANSWERS";
    PRIVILEGES["CAN_ANALYZE_DATA"] = "CAN_ANALYZE_DATA";
    PRIVILEGES["CAN_ADMINISTER_SCHEDULES"] = "CAN_ADMINISTER_SCHEDULES";
    PRIVILEGES["CAN_CREATE_DATA_APP"] = "CAN_CREATE_DATA_APP";
    PRIVILEGES["CAN_CREATE_MUZE_STUDIO_TEMPLATES"] = "CAN_CREATE_MUZE_STUDIO_TEMPLATES";
})(PRIVILEGES || (PRIVILEGES = {}));
const PRIVILEGES_BITMAP_IDX = {
    UNKNOWN: 1,
    ADMINISTRATION: 2,
    AUTHORING: 4,
    USERDATAUPLOADING: 8,
    DATADOWNLOADING: 16,
    USERMANAGEMENT: 32,
    SECURITYMANAGEMENT: 64,
    LOGICALMODELING: 128,
    DATAMANAGEMENT: 256,
    TAGMANAGEMENT: 512,
    SHAREWITHALL: 1024,
    SYSTEMMANAGEMENT: 2048,
    JOBSCHEDULING: 4096,
    A3ANALYSIS: 8192,
    RANALYSIS: 16384,
    THIRDPARTY_ANALYSIS: 32768,
};
export const hasAdminPrivileges = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege === jsonConstants.privilegeType.ADMINISTRATION);
};
export const hasAuthAdminPrivileges = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege ===
        jsonConstants.privilegeType.AUTHENTICATION_ADMINISTRATION);
};
export const canManageVersionControl = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege ===
        jsonConstants.privilegeType.CAN_MANAGE_VERSION_CONTROL);
};
export const canSetupVersionControl = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege === jsonConstants.privilegeType.CAN_SETUP_VERSION_CONTROL);
};
export const hasUserAdminPrivileges = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege === jsonConstants.privilegeType.USER_ADMINISTRATION);
};
export const hasTrustedAuthPrivileges = function (sessionInfo) {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege === jsonConstants.privilegeType.CONTROL_TRUSTED_AUTH);
};
export const hasPrivilege = (sessionInfo, privilege) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return (sessionInfo.privileges.some(permission => permission === privilege) ||
        hasAdminPrivileges(sessionInfo));
};
export const hasCustomCalendarsManagementPrivileges = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege ===
        jsonConstants.privilegeType.CAN_MANAGE_CUSTOM_CALENDAR);
};
export const hasAccessAnalystStudioPrivilege = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege === jsonConstants.privilegeType.CAN_ACCESS_ANALYST_STUDIO);
};
export const hasManageAnalystStudioPrivilege = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege === jsonConstants.privilegeType.CAN_MANAGE_ANALYST_STUDIO);
};
export const hasDataManagementPrivileges = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege === jsonConstants.privilegeType.ADMINISTRATION ||
        privilege === jsonConstants.privilegeType.DATAMANAGEMENT);
};
export const canManageWorksheetViewsTables = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege ===
        jsonConstants.privilegeType.CAN_MANAGE_WORKSHEET_VIEWS_TABLES ||
        privilege === jsonConstants.privilegeType.ADMINISTRATION);
};
export const hasCreateOrEditConnectionsPrivileges = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege ===
        jsonConstants.privilegeType.CAN_CREATE_OR_EDIT_CONNECTIONS);
};
export const hasDeveloperPrivileges = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege === jsonConstants.privilegeType.DEVELOPER);
};
export const hasPreviewThoughtspotSagePrivileges = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege ===
        jsonConstants.privilegeType.PREVIEW_THOUGHTSPOT_SAGE ||
        privilege === jsonConstants.privilegeType.CAN_USE_SPOTTER ||
        privilege === jsonConstants.privilegeType.CAN_MANAGE_SPOTTER);
};
export const hasSchedulingPrivileges = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege === jsonConstants.privilegeType.JOBSCHEDULING);
};
export const getUserPrivileges = sessionInfo => {
    return sessionInfo ? sessionInfo.privileges || [] : [];
};
export const getUserPrivilegesBitMap = sessionInfo => {
    return getUserPrivileges(sessionInfo).reduce((bitMap, privilege) => {
        return bitMap | PRIVILEGES_BITMAP_IDX[privilege];
    }, 0);
};
export const hasDownloadAnswerPrivileges = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege === jsonConstants.privilegeType.ADMINISTRATION ||
        privilege === jsonConstants.privilegeType.DATADOWNLOADING);
};
export const hasDownloadDetailedDataPrivileges = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege === jsonConstants.privilegeType.ADMINISTRATION ||
        privilege === jsonConstants.privilegeType.DATADOWNLOADING ||
        privilege ===
            jsonConstants.privilegeType.CAN_DOWNLOAD_DETAILED_DATA);
};
export const hasDownloadVisualPrivileges = (sessionInfo) => {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege === jsonConstants.privilegeType.ADMINISTRATION ||
        privilege === jsonConstants.privilegeType.DATADOWNLOADING ||
        privilege === jsonConstants.privilegeType.CAN_DOWNLOAD_VISUALS);
};
export function hasTagManagementPrivileges(sessionInfo) {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege === jsonConstants.privilegeType.TAGMANAGEMENT);
}
export function hasViewSystemActivitiesPrivileges(sessionInfo) {
    if (!sessionInfo || !sessionInfo.privileges) {
        return false;
    }
    return sessionInfo.privileges.some(privilege => privilege ===
        jsonConstants.privilegeType.SYSTEM_INFO_ADMINISTRATION);
}
export const hasCreateLiveboardPrivilege = (sessionInfo) => hasPrivilege(sessionInfo, PRIVILEGES.CAN_CREATE_LIVEBOARD);
export const hasCreateAnswersPrivilege = (sessionInfo) => hasPrivilege(sessionInfo, PRIVILEGES.CAN_CREATE_ANSWERS);
export const hasAnalyzeDataPrivilege = (sessionInfo) => hasPrivilege(sessionInfo, PRIVILEGES.CAN_ANALYZE_DATA);
export const hasAdministerSchedulesPrivilege = (sessionInfo) => hasPrivilege(sessionInfo, PRIVILEGES.CAN_ADMINISTER_SCHEDULES);
//# sourceMappingURL=permissions.js.map